import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertTypesContratToString',
})
export class ConvertTypesContratToStringPipe implements PipeTransform {
  transform(values?: string[]): string {
    if (!values || values.length < 1) {
      return '';
    }

    const result = [];
    for (var value of values) {
      switch (value) {
        case 'professionnalisation':
          result.push('Contrat de Professionalisation');
          break;
        case 'apprentissage':
          result.push(`Contrat d'Apprentissage`);
          break;
        default:
          result.push(value);
      }
    }
    return result.join(', ');
  }
}
